import React from "react";
import {Animated, Dimensions, View} from "react-native";
import Tab from "./Tab";
import Indicator from "./Indicator";
import {connect} from "react-redux";

class Tabs extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            measures : [],
            tabActive : 0
        }

        this.containerRef = React.createRef();
        this.setTabActive = this.setTabActive.bind(this);
    }

    updateMeasures() {
      this.getMeasures((measures) => {
        // some measures failed
        if (measures.length !== this.props.data.length) return;

        // either first time we measure or mesure are differents
        const will_update = this.state.measures.length == 0 ||
                            !this._getMesuresEquals(this.state.measures, measures);

        if (will_update) {
          this.setState({ measures });
        }
      })
    }

    getMeasures(cb) {
      let measures = [];
      // measures all tabs
      this.props.data.forEach((item, i) => {
        item.ref.current.measureLayout(
          this.containerRef.current,
          (x, y, width, height) => {
            measures.push({x, y, width, height, item});
            if (i == this.props.data.length - 1) {
              cb(measures); // might not be called if could not measure
            }
          }
        );
      })
    }

    componentDidMount() { this.updateMeasures(); }
    componentDidUpdate() { this.updateMeasures(); }

    // only check that x are equals?
    _getMesuresEquals(m1,m2){
        if(!m2.length || !m1.length) {
            return false;
        }

        let equals = true;
        let cpt = 0;
        while (cpt<m1.length-1 && equals){
            equals  = m1[cpt].x===m2[cpt].x && m1[cpt].y && m2[cpt].x && m1[cpt].width && m1[cpt].height
        }
        return equals;
    }

    setTabActive(index){
        this.setState({ tabActive : index })
    }

    render() {
        const width = this.props.total_width

        const animated_view_style = [{height:30, position:"absolute", paddingTop:14, width: width}, this.props.style]

	const tabcontent_widths = this.props.data.map((_,i)=> i * width);

        return <Animated.View style={animated_view_style}>
            { this.state.measures.length > 0 && this.state.measures.length ==this.props.data.length  &&
              <Animated.View>
                <Indicator measures={this.state.measures} tabcontent_widths={tabcontent_widths}
			   scrollX={this.props.scrollX} />
              </Animated.View>
            }

            <View ref={this.containerRef} style={{justifyContent: (this.props.scroll)? "flex-start":'center', flex:1,flexDirection:"row"}}>
                {this.props.data.map((item,index) => {
                    return <Tab key={item.key} index={index} item={item} mref={item.ref} isActive={(this.props.indexActive == index)}
                            onPressCallBack={this.props.onItemPressCallBack} onItemPress={this.props.onItemPress} />
                })}
            </View>


        </Animated.View>
    };
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(Tabs);
